import './ProjectAdmin.scss'
import ProjectAdminModel from './ProjectAdminModel'
import ProjectAdminController from './ProjectAdminController'
import PaperItem from '../../../components/Essential/PaperItem'
import { Dialog, DialogContent, DialogTitle, Grid2, IconButton, Tooltip, Typography } from '@mui/material'
import TableComponent from '../../../components/TableComponent'
import * as CONSTANTS from '../../../utils/TableColumnsConstants'
import { useTranslation } from 'react-i18next'
import { Onboarding } from '../../../components/Onboarding/Onboarding'
import { ONBOARDING_FIRST_ACCOUNT, ONBOARDING_FIRST_PROJECT } from '../../../utils/Constants'
import SplitButton from '../../../components/SplitButton'
import * as React from 'react'
import ProjectSelector from './ProjectSelector'
import CloseIcon from '@mui/icons-material/Close'
import Splash from '../../../components/Splash'


const ProjectAdminView = () => {
  const { t } = useTranslation()

  const model = ProjectAdminModel()
  const controller = ProjectAdminController(model)

  if(model.accountsLoaded!==true) {
    return <Splash />
  }

  return (
    <>
      <Dialog fullWidth  open={model.projectsDialogOpened} className='projectSelectorDialog' disableScrollLock>
        <DialogTitle variant='body1' className='title'><Tooltip title={t('tooltip.selectProject')} followCursor arrow>{t('selectProject')}</Tooltip></DialogTitle>
        <IconButton
          aria-label="close"
          onClick={controller.handleOnboardingAddProjectClick}
          sx={(theme) => ({ position: 'absolute', right: 8, top: 8, color: theme.palette.grey[500] })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent><ProjectSelector model={model} /></DialogContent>
      </Dialog>

      {/* Check if accounts exist and are empty */}
      {model.accounts && model.accounts.length === 0 ? (
          <Onboarding data={ONBOARDING_FIRST_ACCOUNT} onClick={controller.handleOnboardingAddAccountClick} />
        ) :
        // If accounts are fine, check if projects exist and are empty
        model.projects && model.projects.length === 0 ? (
          <Onboarding data={ONBOARDING_FIRST_PROJECT} onClick={controller.handleOnboardingAddProjectClick} />
        ) : (
          // If both accounts and projects are set up, show the list of projects
          <>
          <Grid2 container spacing={2} className='container-analysis'>
            <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
              <PaperItem className='boxShadow' sx={{ p: 3 }}>
                <Grid2 container justifyContent='space-between'>
                  <Grid2>
                    <Typography className='title'>{t('projects')}</Typography>
                  </Grid2>
                  <Grid2>
                    <SplitButton
                      //loading={loading}
                      onClick={controller.handleOnboardingAddProjectClick}
                      onClickAccount={controller.handleOnboardingAddAccountClick}
                    />
                  </Grid2>
                </Grid2>
              </PaperItem>
            </Grid2>

            <Grid2 size={{ xs: 12 }}>
              <PaperItem className='boxShadow' sx={{ p: 3, height: '100%' }}>
                <TableComponent
                  className='fullHeight'
                  rowBuffer={0}
                  columnBuffer={0}
                  getRowHeight={() => 'auto'}
                  rows={model.projects}
                  loading={model.isLoading.keywordOverview}
                  columns={CONSTANTS.COLUMNS_PROJECTS_ADMIN_MANAGE(t, { model: model })}
                  paginationMode='client'
                  sortingMode='client'
                  hideFooter={model.projects.length<11}
                />
              </PaperItem>
            </Grid2>

          </Grid2>
        </>

        )}

    </>
  )
}

export default ProjectAdminView
